import React, { useState } from "react";

import { CreateAgentDto } from "../../types/app.types";
import { colorToHex, hexToHSL } from "../../helpers/general_helpers";

const DEFAULT_NEW_AGENT_COLOR = "hsl(0, 0%, 100%)";

interface AgentFormProps {
  onAddAgent: (agentDto: CreateAgentDto) => Promise<void>;
  setError: (message: string | null) => void;
}

export const AgentForm: React.FC<AgentFormProps> = ({
  onAddAgent,
  setError,
}) => {
  const [name, setName] = useState("");
  const [color, setColor] = useState(DEFAULT_NEW_AGENT_COLOR);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError("Назва агента не може бути порожньою.");
      return;
    }
    await onAddAgent({ name, color });
    setName("");
    setColor(DEFAULT_NEW_AGENT_COLOR);
  };

  const handleColorChange = (hexColor: string) => {
    setColor(hexToHSL(hexColor));
  };

  return (
    <div className="agents-card">
      <h2 className="agents-card-title">Додати нового агента</h2>
      <form onSubmit={handleSubmit} className="add-agent-form">
        <input
          type="text"
          placeholder="Назва нового агента"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="agent-input"
        />
        <div className="color-input-wrapper">
          <input
            type="color"
            value={colorToHex(color)}
            onChange={(e) => handleColorChange(e.target.value)}
            className="agent-color-input"
          />
        </div>
        <button type="submit" className="add-agent-btn">
          Додати
        </button>
      </form>
    </div>
  );
};
